<template>
  <v-container class="main-container d-flex flex-column justify-center">
    <div class="my-9">
      <!-- Mode Switcher -->
      <!--<v-row no-gutters align="center" class="">
        <v-col cols="10" md="5" offset="1" offset-md="0" class="mb-5 align--right">
          <span class="pr-3 text-label">{{ $t("mode") }}</span>
        </v-col>
        <v-col cols="10" md="5" offset="1" offset-md="0" class="text-center mb-5">
          <v-radio-group v-model="selectedMode" mandatory row>
            <v-radio
              v-for="mode in [$t('online'), $t('live')]"
              :key="mode"
              :label="mode"
              :color="uiColor"
              :value="mode"
              class="black--text radio-button--margin"
            ></v-radio>
          </v-radio-group>
        </v-col>
      </v-row>-->
      <!-- Live Dates -->
      <v-row no-gutters align="center" v-if="selectedMode === $t('live')">
        <v-col cols="2" class="text-margin align--right mr-5" aria-hidden="true">
          <span class="text-label">{{ $t("date") }}:</span>
        </v-col>
        <v-col cols="8" class="dropdown">
          <v-select
            class="select"
            :items="liveDatesAvailable"
            item-value="examID"
            attach
            solo
            dense
            :color="uiColor"
            v-model="selectedLiveExam"
            item-:color="uiColor"
            :class="{
              'input-error': $v.selectedLiveExam.$error,
              focused: focused1,
            }"
            @focus="focused1 = true"
            @blur="focused1 = false"
            :aria-label="$t('date')"
          >
            <template slot="selection" slot-scope="data">
              {{ liveDateValue(data) }}
            </template>
            <template slot="item" slot-scope="data">
              {{ liveDateValue(data) }}
            </template>
          </v-select>
        </v-col>
      </v-row>
      <!-- Timezone -->
      <v-row no-gutters align="center" v-if="selectedMode === $t('online') && timezoneEnabled === 'true'">
        <v-col cols="10" md="6" offset="1" offset-md="0" class="text-margin align--right" aria-hidden="true">
          <span class="pr-3 text-label">{{ $t("timezone") }}</span>
        </v-col>
        <v-col cols="10" md="4" offset="1" offset-md="0" class="dropdown">
          <v-autocomplete
            :items="availableTimezones"
            attach
            solo
            dense
            :label="$t('timezone')"
            class="select"
            :color="uiColor"
            v-model="selectedTimezone"
            item-:color="uiColor"
            :class="{
              'input-error': $v.selectedTimezone.$error,
              focused: focused0,
            }"
            @focus="focused0 = true"
            @blur="focused0 = false"
            data-test="select-timezone"
            :aria-label="$t('timezone')"
          ></v-autocomplete>
          <div v-if="$v.selectedTimezone.$error" class="input-error--info-text">
            {{ $i18n.t("required_field") }}
          </div>
        </v-col>
      </v-row>

      <!-- Datum -->
      <v-row no-gutters align="center" v-if="selectedMode === $t('online')">
        <v-col cols="10" md="6" offset="1" offset-md="0" class="text-margin align--right" aria-hidden="true">
          <span class="pr-3 text-label">{{ dateSelectorTitle }}</span>
        </v-col>
        <v-col cols="10" md="4" offset="1" offset-md="0" v-if="loadingDates" align="center">
          <v-progress-circular
            :size="30"
            :width="3"
            :color="uiColor"
            indeterminate
            :aria-label="$t('loading')"
            aria-busy="true"
            aria-live="polite"
          ></v-progress-circular>
        </v-col>
        <v-col
          cols="10"
          md="4"
          offset="1"
          offset-md="0"
          class="dropdown"
          v-on:click="toggleDatePicker()"
          v-if="!loadingDates"
          data-test="menu-date"
        >
          <v-menu
            v-model="menu"
            :close-on-content-click="true"
            transition="scale-transition"
            offset-y
            min-width="290px"
            max-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="selectedDate"
                :append-icon="'$vuetify.icons.menuDown'"
                solo
                dense
                readonly
                :color="uiColor"
                v-bind="attrs"
                v-on="on"
                :disabled="preloaded && availableDates.length === 1"
                class="select"
                :class="{
                  'input-error': $v.selectedDate.$error,
                  focused: focused1,
                  'select-cursor': !(preloaded && availableDates.length === 1),
                }"
                tabindex="0"
                @focus="focused1 = true"
                @blur="focused1 = false"
                @keydown.enter="toggleDatePicker()"
                @keydown.esc="menu = false"
                @keydown.down="down"
                @keydown.up="up"
                @keydown.left="left"
                @keydown.right="right"
                :aria-label="dateSelectorTitle"
                :aria-disabled="preloaded && availableDates.length === 1"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="selectedDate"
              no-title
              :locale="datePickerLocale"
              :color="uiColor"
              :show-current="nextAvailableDate()"
              :allowed-dates="allowedDates"
              @input="menu = false"
              class="date-picker"
              first-day-of-week="1"
              tabindex="0"
            ></v-date-picker>
          </v-menu>
          <div v-if="$v.selectedDate.$error" class="input-error--info-text">
            {{ $i18n.t("required_field") }}
          </div>
        </v-col>
      </v-row>
      <!-- Uhrzeit -->
      <v-row no-gutters align="center" v-if="selectedMode === $t('online') && showTimeSelector">
        <v-col cols="10" md="6" offset="1" offset-md="0" class="text-margin align--right" aria-hidden="true">
          <span class="text-label">{{ $t("time") }}</span>
          <span class="pr-3 text-label" v-if="selectedTimezone"> ({{ selectedTimezone }})</span>
        </v-col>
        <v-col cols="10" md="4" offset="1" offset-md="0" v-if="loadingTimes" align="center">
          <v-progress-circular
            :size="30"
            :width="3"
            :color="uiColor"
            indeterminate
            :aria-label="$t('loading')"
            aria-busy="true"
            aria-live="polite"
          ></v-progress-circular>
        </v-col>
        <v-col cols="10" md="4" offset="1" offset-md="0" class="dropdown" v-if="!loadingTimes">
          <v-select
            class="select"
            :items="availableTimes"
            item-text="timezonedTimeFormatted"
            item-value="timezonedTime"
            attach
            solo
            dense
            :color="uiColor"
            :disabled="!selectedDate || selectedDate === '' || (preloaded && availableTimes.length === 1)"
            v-model="selectedTime"
            item-:color="uiColor"
            :class="{
              'input-error': $v.selectedTime.$error,
              focused: focused2,
            }"
            @focus="focused2 = true"
            @blur="focused2 = false"
            data-test="select-time"
            :aria-label="$t('time')"
            :aria-disabled="!selectedDate || selectedDate === '' || (preloaded && availableTimes.length === 1)"
          ></v-select>
          <div v-if="$v.selectedTime.$error" class="input-error--info-text">
            {{ $i18n.t("required_field") }}
          </div>
        </v-col>
      </v-row>
      <!-- Papirzertifikat -->
      <v-row no-gutters :class="{ 'checkbox-margin': !preloaded }" v-if="tenant === 'ai' && !paperExam">
        <v-col cols="0" md="1"></v-col>
        <v-col cols="12" md="9" align="left">
          <v-checkbox v-model="paperCertificateLegacy" :color="uiColor">
            <span slot="label" class="text-label text-justify">{{ $t("paper_certificate") }}</span>
          </v-checkbox>
        </v-col>
      </v-row>
      <!-- Studentenrabatt -->
      <v-row no-gutters class="checkbox-margin" v-if="studentDiscountAvailable && !paperExam">
        <v-col cols="0" md="1"></v-col>
        <v-col cols="12" md="9" align="left">
          <v-checkbox v-model="studentDiscount" :color="uiColor">
            <span slot="label" class="text-label text-justify"
              >{{ $t("student_discount[0]") }}
              <a
                @click.stop
                target="_blank"
                rel="noopener noreferrer"
                class="text-link--lib"
                href="https://www.certible.com/de/Konditionen/Pruefungsgebuehren/#Discounts"
                >{{ $t("student_discount[1]") }}</a
              >
              {{ $t("student_discount[2]") }}</span
            >
          </v-checkbox>
        </v-col>
      </v-row>
      <!-- Zeitverlängerung -->
      <v-row no-gutters class="checkbox-margin" v-if="extraTimeAvailable && tenant !== 'as' && !paperExam">
        <v-col cols="0" md="1"></v-col>
        <v-col cols="12" md="9" align="left">
          <v-checkbox v-model="extraTime" :color="uiColor">
            <component
              slot="label"
              class="text-label text-justify"
              :is="convertLink($i18n.t('extra_time'))"
            ></component>
          </v-checkbox>
        </v-col>
      </v-row>
      <!-- ISTQB SCR -->
      <v-row no-gutters class="checkbox-margin" v-if="owner === 'ISTQB'">
        <v-col cols="0" md="1"></v-col>
        <v-col cols="12" md="9" align="left">
          <v-checkbox v-model="istqbSrc" :color="uiColor">
            <component slot="label" class="text-label text-justify" :is="convertLink($i18n.t('istqb_scr'))"></component>
          </v-checkbox>
        </v-col>
      </v-row>
      <!-- Anforderungen -->
      <v-row no-gutters class="checkbox-margin" v-if="admissionRequiremetsNeeded">
        <v-col cols="0" md="1"></v-col>
        <v-col cols="12" md="9" align="left">
          <v-checkbox
            v-model="admissionRequirements"
            :color="uiColor"
            :class="{ 'input-error-checkbox': $v.admissionRequirements.$error }"
          >
            <span
              slot="label"
              class="text-label text-justify"
              :class="{
                'input-error--text': $v.admissionRequirements.$error,
              }"
              >{{ $t("exam_requirements") }}
            </span>
          </v-checkbox>
          <div v-if="$v.admissionRequirements.$error" class="input-error--info-text">
            {{ $i18n.t("required_field") }}
          </div>
        </v-col>
      </v-row>
      <!-- Papirzertifikat mit Donation -->
      <v-row
        no-gutters
        :class="{ 'checkbox-margin': !preloaded }"
        v-if="tenant === 'certible' && !hideCertificateDeliveryOptions"
      >
        <v-col cols="0" md="1"></v-col>
        <v-col cols="12" md="9" align="left">
          <v-divider class="mt-5"></v-divider>
          <div class="text-bold mt-5 mb-2">{{ $t("paper_certificate_1") }}</div>
          <v-radio-group
            v-model="paperCertificate"
            :color="uiColor"
            :class="{ 'input-error-radio': $v.paperCertificate.$error }"
          >
            <v-radio
              v-for="certOption in $t('paper_certificate')"
              :key="certOption.key"
              :value="certOption.key"
              class="text-label"
              :color="uiColor"
              :class="{
                'black--text': !$v.paperCertificate.$error,
                'input-error--text': $v.paperCertificate.$error,
              }"
            >
              <template slot="label">
                <component :is="convertLink(certOption.text)"></component>
              </template>
            </v-radio>
          </v-radio-group>
          <div v-if="$v.paperCertificate.$error" class="input-error--info-text">
            {{ $i18n.t("required_field") }}
          </div>
        </v-col>
      </v-row>
    </div>
    <!-- Navigation Buttons -->
    <div>
      <v-btn tile :color="uiColor" class="next-button" v-on:click="validateForm()" data-test="button-next">{{
        $t("proceed")
      }}</v-btn>
      <v-btn tile :color="uiColor" class="back-button" v-on:click="$emit('back-button-clicked')">{{
        $t("back")
      }}</v-btn>
    </div>
  </v-container>
</template>

<script>
import { required, sameAs, requiredIf } from "vuelidate/lib/validators";
import { formatInTimeZone, zonedTimeToUtc } from "date-fns-tz";
import { convertLink, isAM_PM } from "../utils/utils";
import { getTimeslots } from "../services/PublicApiService";

export default {
  name: "ExamDate",
  components: {},
  mounted() {
    this.getAvailableDates();
  },
  data() {
    return {
      focused0: false,
      focused1: false,
      focused2: false,
      menu: false,
      owner: this.$store.getters["registration/certificate"].owner,
      certificateValidTo: this.$store.getters["registration/certificateValidTo"],
      certificateValidFrom: this.$store.getters["registration/certificateValidFrom"],
      preloaded: this.$store.getters["registration/examPreloaded"],
      studentDiscountAvailable: this.$store.getters["registration/studentDiscountAvailable"],
      extraTimeAvailable: this.$store.getters["registration/extraTimeAvailable"],
      admissionRequiremetsNeeded: this.$store.getters["registration/admissionRequiremetsNeeded"],
      applicationAllowedUntil: this.$store.getters["registration/applicationAllowedUntil"],
      admissionRequirements: false,
      uiColor: this.$store.getters["registration/uiColor"],
      tenant: this.$store.getters["registration/tenant"],
      selectedCertId: this.$store.getters["registration/certId"],
      locale: this.$store.getters["registration/locale"],
      onlineText: this.$t("online"),
      liveText: this.$t("live"),
      nextDayEnabled: this.$store.getters["registration/nextDayEnabled"],
      availableDates: [],
      availableTimes: [],
      loadingDates: false,
      loadingTimes: false,
      examId: this.$store.getters["registration/examId"],
      timezoneEnabled: process.env.VUE_APP_TIMEZONE_ENABLED,
    };
  },
  validations: {
    selectedTimezone: {
      required: requiredIf(function () {
        return this.selectedMode === this.onlineText;
      }),
    },
    selectedDate: {
      required: requiredIf(function () {
        return this.selectedMode === this.onlineText;
      }),
    },
    selectedTime: {
      required: requiredIf(function () {
        return this.selectedMode === this.onlineText && this.showTimeSelector;
      }),
    },
    admissionRequiremetsNeeded: {
      required,
    },
    admissionRequirements: {
      sameAs: sameAs("admissionRequiremetsNeeded"),
    },
    selectedLiveExam: {
      required: requiredIf(function () {
        return this.selectedMode === this.liveText;
      }),
    },
    paperCertificate: {
      required: requiredIf(function () {
        return this.tenant === "certible" && !this.hideCertificateDeliveryOptions;
      }),
    },
  },
  methods: {
    convertLink,
    async getAvailableDates() {
      this.loadingDates = true;
      let timeslots = await getTimeslots(
        this.$store.getters["registration/env"].backendUrl,
        this.provider,
        this.selectedCertId,
        this.examId,
        this.nextDayEnabled,
        null,
        this.applicationAllowedUntil,
        null,
        this.trainer
      );
      timeslots = timeslots.timeslots.map((timeslot) =>
        formatInTimeZone(timeslot, this.selectedTimezone, "yyyy-MM-dd")
      );
      this.availableDates = [...new Set(timeslots)];
      if (this.availableDates.length === 1) {
        this.$store.dispatch("registration/updateDate", this.availableDates[0]);
        this.getAvailableTimeslots();
      } else {
        this.$store.dispatch("registration/updateDate", null);
      }
      this.$store.dispatch("registration/updateTime", null);
      this.loadingDates = false;
    },
    async getAvailableTimeslots() {
      console.log("exam duration", this.examDuration);
      this.loadingTimes = true;
      let dateStart = zonedTimeToUtc(`${this.selectedDate}T00:00:00`, this.selectedTimezone);
      dateStart = dateStart.toISOString();
      let dateEnd = zonedTimeToUtc(`${this.selectedDate}T23:59:59`, this.selectedTimezone);
      dateEnd = dateEnd.toISOString();
      let timeslots = await getTimeslots(
        this.$store.getters["registration/env"].backendUrl,
        this.provider,
        this.selectedCertId,
        this.examId,
        this.nextDayEnabled,
        dateStart,
        dateEnd,
        this.examDuration,
        this.trainer
      );
      this.availableTimes = timeslots.timeslots
        .filter((timeslot) =>
          formatInTimeZone(timeslot, this.selectedTimezone, "yyyy-MM-dd - HH:mm").startsWith(this.selectedDate)
        )
        .map((timeslot) => ({
          utc: timeslot,
          utcTime: timeslot.slice(11, 16),
          timezonedTime: formatInTimeZone(timeslot, this.selectedTimezone, "yyyy-MM-dd - HH:mm").slice(-5),
          timezonedTimeFormatted: isAM_PM(this.selectedTimezone)
            ? formatInTimeZone(timeslot, this.selectedTimezone, "yyyy-MM-dd - hh:mm a").slice(-8)
            : formatInTimeZone(timeslot, this.selectedTimezone, "yyyy-MM-dd - HH:mm").slice(-5),
        }));
      if (this.availableTimes.length === 1) {
        this.$store.dispatch("registration/updateTime", this.availableTimes[0].timezonedTime);
      }
      this.loadingTimes = false;
    },
    liveDateValue(data) {
      return `${formatInTimeZone(
        new Date(data.item.date + "T" + data.item.time + "Z"),
        data.item.timezone,
        "yyyy-MM-dd - HH:mm"
      )} - ${data.item.city}`;
    },
    allowedDates(val) {
      var dateAllowed = false;
      if (this.availableDates.includes(val)) {
        dateAllowed = true;
      }
      val = new Date(val);
      val.setHours(0, 0, 0, 0);
      if (this.certificateValidTo) {
        var validTo = new Date(this.certificateValidTo);
        validTo.setHours(0, 0, 0, 0);
        if (val > validTo) {
          return false;
        }
      }
      if (this.certificateValidFrom) {
        var validFrom = new Date(this.certificateValidFrom);
        validFrom.setHours(0, 0, 0, 0);
        if (val < validFrom) {
          return false;
        }
      }
      return dateAllowed;
    },
    up() {
      var val = new Date(this.selectedDate);
      var today = new Date();
      var dateString = "";
      do {
        val.setDate(val.getDate() - 7);
        dateString = this.dateToString(val);
      } while (!this.allowedDates(dateString));
      if (val >= today) {
        this.selectedDate = dateString;
      }
    },
    down() {
      var val = new Date(this.selectedDate);
      var dateString = "";
      do {
        val.setDate(val.getDate() + 7);
        dateString = this.dateToString(val);
      } while (!this.allowedDates(dateString));
      this.selectedDate = dateString;
    },
    left() {
      var val = new Date(this.selectedDate);
      var today = new Date();
      var dateString = "";
      do {
        val.setDate(val.getDate() - 1);
        dateString = this.dateToString(val);
        if (val < today) {
          break;
        }
      } while (!this.allowedDates(dateString));
      if (val >= today) {
        this.selectedDate = dateString;
      }
    },
    right() {
      var val = new Date(this.selectedDate);
      var dateString = "";
      do {
        val.setDate(val.getDate() + 1);
        dateString = this.dateToString(val);
      } while (!this.allowedDates(dateString));
      this.selectedDate = dateString;
    },
    validateForm() {
      this.$v.$touch();
      if (!this.$v.$error) {
        this.$emit("next-button-clicked");
      }
    },
    dateToString(date) {
      return (
        date.getFullYear() +
        "-" +
        String(date.getMonth() + 1).padStart(2, "0") +
        "-" +
        String(date.getDate()).padStart(2, "0")
      );
    },
    nextAvailableDate() {
      if (this.availableDates.length > 0) {
        return this.availableDates[0];
      } else {
        return "";
      }
    },
    toggleDatePicker() {
      if (!this.preloaded) {
        this.menu = !this.menu;
      }
    },
  },
  computed: {
    paperExam() {
      return this.$store.getters["registration/paperExam"];
    },
    provider() {
      return this.$store.getters["registration/provider"];
    },
    trainer() {
      return this.$store.getters["registration/trainer"];
    },
    examDuration() {
      return this.$store.getters["registration/examDuration"];
    },
    hideCertificateDeliveryOptions() {
      return this.$store.getters["registration/hideCertificateDeliveryOptions"];
    },
    availableTimezones() {
      return this.$store.getters["registration/availableTimezones"];
    },
    showTimeSelector() {
      return !(this.$store.getters["registration/certificate"].overrides?.options?.showTimeSelector === false);
    },
    dateSelectorTitle() {
      if (this.$store.getters["registration/certificate"].overrides?.strings?.dateSelectorTitle?.[this.locale]) {
        return this.$store.getters["registration/certificate"].overrides.strings.dateSelectorTitle[this.locale];
      } else {
        return this.$t("date");
      }
    },
    datePickerLocale() {
      if (this.locale === "de") {
        return "de-DE";
      } else if (this.locale === "it") {
        return "it-IT";
      } else if (this.locale === "fr") {
        return "fr-Fr";
      } else if (this.locale === "nl") {
        return "nl-NL";
      } else {
        return "en-GB";
      }
    },
    selectedDate: {
      get() {
        return this.$store.getters["registration/date"];
      },
      set(value) {
        this.$store.dispatch("registration/updateDate", value);
        this.$store.dispatch("registration/updateTime", null);
        if (value) {
          this.getAvailableTimeslots();
        }
      },
    },
    selectedTimezone: {
      get() {
        return this.$store.getters["registration/timezone"];
      },
      set(value) {
        this.$store.dispatch("registration/updateTimezone", value);
        this.getAvailableDates();
      },
    },
    selectedTime: {
      get() {
        return this.$store.getters["registration/time"];
      },
      set(value) {
        this.$store.dispatch("registration/updateTime", value);
      },
    },
    paperCertificate: {
      get() {
        return this.$store.getters["registration/paperCertificate"];
      },
      set(value) {
        this.$store.dispatch("registration/updatePaperCertificate", value);
      },
    },
    paperCertificateLegacy: {
      get() {
        return this.$store.getters["registration/paperCertificateLegacy"];
      },
      set(value) {
        this.$store.dispatch("registration/updatePaperCertificateLegacy", value);
      },
    },
    studentDiscount: {
      get() {
        return this.$store.getters["registration/studentDiscount"];
      },
      set(value) {
        this.$store.dispatch("registration/updateStudentDiscount", value);
      },
    },
    extraTime: {
      get() {
        return this.$store.getters["registration/extraTime"];
      },
      set(value) {
        this.$store.dispatch("registration/updateExtraTime", value);
        if (this.selectedDate) {
          this.$store.dispatch("registration/updateTime", null);
          this.getAvailableTimeslots();
        }
      },
    },
    istqbSrc: {
      get() {
        return this.$store.getters["registration/istqbSrc"];
      },
      set(value) {
        this.$store.dispatch("registration/updateIstqbSrc", value);
      },
    },
    selectedMode: {
      get() {
        return this.$store.getters["registration/mode"];
      },
      set(value) {
        this.$store.dispatch("registration/updateMode", value);
        this.selectedLiveExam = null;
        this.selectedDate = null;
        this.selectedTime = null;
        this.$store.dispatch("registration/updateCity", null);
        this.$store.dispatch("registration/updateTimezone", null);
        this.$store.dispatch("registration/updateConsentDeclarationsExam", null);
        this.$store.dispatch("registration/updateNoPay", false);
        this.$store.dispatch("registration/updateExamId", null);
      },
    },
    liveDatesAvailable() {
      return this.$store.getters["registration/liveDatesAvailable"];
    },
    selectedLiveExam: {
      get() {
        return this.$store.getters["registration/examId"];
      },
      set(value) {
        if (!value) {
          this.$store.dispatch("registration/updateExamId", null);
        } else {
          const exam = this.$store.getters["registration/liveDatesAvailable"].find((x) => x.examID === value);
          console.log("value", exam);
          const dateTimeUTC = `${exam.date}T${exam.time}:00Z`;
          this.$store.dispatch(
            "registration/updateDate",
            formatInTimeZone(dateTimeUTC, exam.timezone, "yyyy-MM-dd - HH:mm").slice(0, 10)
          );
          this.$store.dispatch(
            "registration/updateTime",
            formatInTimeZone(dateTimeUTC, exam.timezone, "yyyy-MM-dd - HH:mm").slice(-5)
          );
          this.$store.dispatch("registration/updateTimezone", exam.timezone);
          this.$store.dispatch("registration/updateConsentDeclarationsExam", exam.consentDeclarations);
          this.$store.dispatch("registration/updateNoPay", exam.noPay);
          this.$store.dispatch("registration/updateExamId", exam.examID);
          this.$store.dispatch("registration/updateCity", exam.city);
        }
      },
    },
  },
};
</script>

<style scoped>
.main-container {
  height: 100%;
}
.text-margin {
  margin-bottom: 24px;
}
.v-text-field.v-text-field--enclosed .v-text-field__details {
  height: 0;
  padding: 0;
  margin: 0;
}
.checkbox-margin {
  margin-top: -24px !important;
}
@media (max-width: 960px) {
  .align--right {
    text-align: left !important;
  }
  .main-container {
    height: fit-content !important;
  }
  .text-margin {
    margin-bottom: 12px;
  }
  .dropdown {
    margin-bottom: -12px;
  }
}
.align--right {
  text-align: right;
}
.input-error ::v-deep .v-input__slot {
  box-shadow: 0px 3px 1px -2px rgba(240, 64, 79, 0.2), 0px 2px 2px 0px rgba(240, 64, 79, 0.2),
    0px 1px 5px 0px rgba(240, 64, 79, 0.2) !important;
}
.input-error-checkbox ::v-deep i {
  color: rgba(240, 64, 79, 0.8);
}
.input-error--text ::v-deep label {
  font-size: 16px;
  color: #f03434 !important;
}
.black--text ::v-deep label {
  font-size: 16px;
  color: rgba(0, 0, 0, 0.7);
}
.select.focused ::v-deep .v-input__slot {
  box-shadow: 0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 6px 10px 0px rgba(0, 0, 0, 0.14),
    0px 1px 18px 0px rgba(0, 0, 0, 0.12) !important;
}
.select-cursor ::v-deep input {
  cursor: pointer !important;
}
.select-cursor ::v-deep .v-input__slot {
  cursor: pointer !important;
}
.input-error-radio ::v-deep i {
  color: rgba(240, 64, 79, 0.8);
}
</style>
